import React, { useState, useEffect, useContext } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Row, Col, Card, Button, Form } from 'react-bootstrap';
import { useNavigate, useLocation, useParams } from "react-router-dom";
import Navbar from "../../../../../Shared/ManagerNavbar/Navbar";
import "./InDetailViewLeads.css";
import axios from "axios";
import { baseURL } from "../../../../../Apiservices/Api";
import { AuthContext } from '../../../../../AuthContext/AuthContext';
import { adminMail } from '../../../../../Apiservices/Api';
import { ThemeContext } from "../../../../../Shared/Themes/ThemeContext";
import { FaCopy, FaTimes, FaCheck, FaTrash } from "react-icons/fa";

const InDetailViewLeads = () => { 
  const { authToken, userRole, userId, userName, assignManager, managerId } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();
  const source = location.state?.source;
  const { themeColor } = useContext(ThemeContext);
  const [assignedSalesId, setAssignedSalesId] = useState(null);
  // const { leadid } = location.state;
  const { leadid } = useParams();
  const [collapsed, setCollapsed] = useState(false);
  const [newComment, setNewComment] = useState('');
  const [lead, setLead] = useState({ comments: [] });
  const [availableTags, setAvailableTags] = useState([]);
  const [customerTags, setCustomerTags] = useState([]);
  const [selectedTagId, setSelectedTagId] = useState("");
  const [isUpdating, setIsUpdating] = useState(false);
  const [tagsLoading, setTagsLoading] = useState(true);
  const [reminderHistory, setReminderHistory] = useState([]);
  const [reminderFormData, setReminderFormData] = useState({
    reminder_setting: "",
    notes: "",
  });
  const [templates, setTemplates] = useState([]);
const [showTemplates, setShowTemplates] = useState(false);
  const [formData, setFormData] = useState({
    lead_type: "",
    name: "",
    email: "",
    country_code: "",
    another_country_code: "",
    phone_number: "",
    sources: "",
    origincity: "",
    destination: "",
    description: "",
    another_name: "",
    another_email: "",
    another_phone_number: "",
    corporate_id: "",
    primaryStatus: "",
    secondaryStatus: "",
    primarySource: "",
    secondarysource: "",
    channel: "",
    created_at: "",
  });
  const [error, setError] = useState(null);
  const [message, setMessage] = useState('');
  
  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      setMessage("Copied to clipboard!");
      setTimeout(() => setMessage(""), 1000); // Optional: Show a message
    }).catch(err => {
      console.error('Failed to copy: ', err);
    });
  };

  // Fetch assignedSalesId for the lead
  useEffect(() => {
    const fetchLeadDetails = async () => {
      try {
        const leadResponse = await axios.get(`${baseURL}/api/leads/${leadid}`);
        setAssignedSalesId(leadResponse.data.assignedSalesId);
      } catch (error) {
        console.error("Error fetching lead details:", error);
      }
    };

    fetchLeadDetails();
  }, [leadid]);

  // Fetch reminder history
  useEffect(() => {
    if (leadid) {
      fetchReminderHistory(leadid);
    }
  }, [leadid]);

  const fetchReminderHistory = async (leadId) => {
    try {
      const response = await axios.get(`${baseURL}/reminder_settinglead/${leadId}`);
      console.log("Fetched reminder history:", response.data);
      setReminderHistory(response.data);
    } catch (error) {
      console.error("Error fetching reminder history:", error);
      if (error.response?.status !== 404) {
        setMessage("Failed to load reminder history");
      }
    }
  };

  // Handle reminder form change
  const handleReminderChange = (e) => {
    const { name, value } = e.target;
    setReminderFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Handle reminder submit
const handleReminderSubmit = async (e) => {
  e.preventDefault();

  if (!reminderFormData.reminder_setting && !reminderFormData.notes.trim()) {
    alert("Please fill in at least Reminder Setting or Notes.");
    return;
  }

  try {
    // Format datetime for MySQL
    let reminderValue = null;
    if (reminderFormData.reminder_setting) {
      const localDate = new Date(reminderFormData.reminder_setting);
      const year = localDate.getFullYear();
      const month = String(localDate.getMonth() + 1).padStart(2, "0");
      const day = String(localDate.getDate()).padStart(2, "0");
      const hours = String(localDate.getHours()).padStart(2, "0");
      const minutes = String(localDate.getMinutes()).padStart(2, "0");
      const seconds = "00";
      reminderValue = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    }
const payload = {
  notes: reminderFormData.notes.trim() || null,
  userId: userId,  // Manager's ID (32)
  assignedSalesId: assignedSalesId,  // Sales person's ID (if needed)
  reminder_setting: reminderValue,
};

    console.log("Sending payload:", payload);
    console.log("Current userId (manager):", userId);

    const response = await fetch(
      `${baseURL}/api/travelopportunity-setting/by-lead/${leadid}`,
      {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      }
    );

    const result = await response.json();
    if (response.ok) {
      alert("Reminder & Notes updated successfully!");
      fetchReminderHistory(leadid);
      setReminderFormData({ reminder_setting: "", notes: "" });
    } else {
      alert("Update failed: " + result.message);
    }
  } catch (error) {
    console.error("Error submitting form:", error);
    alert("Something went wrong!");
  }
};

  // Handle delete reminder
  const handleDeleteReminder = async (reminderId, leadId) => {
    if (!reminderId) {
      alert("Invalid reminder ID");
      return;
    }

    const confirmDelete = window.confirm("Are you sure you want to delete this reminder?");
    if (!confirmDelete) return;

    try {
      const response = await axios.delete(
        `${baseURL}/reminder_settinglead/${leadId}/${reminderId}/${userId}`
      );      
      if (response.status === 200) {
        alert("Reminder deleted successfully!");
        fetchReminderHistory(leadId);
      }
    } catch (error) {
      console.error("Error deleting reminder:", error);
      if (error.response?.status === 404) {
        alert("Reminder not found or you are not authorized to delete it");
      } else {
        alert("Failed to delete reminder. Please try again.");
      }
    }
  };

  useEffect(() => {
      const checkDataExists = async () => {
        try {
          const response = await fetch(`${baseURL}/api/manager-leadid/leads/${leadid}/${userId}`);
          const data = await response.json();
  
          if (response.ok) {
            console.log(data.message); // Should print "Exists"
          } else {
            console.error(data.error);
            navigate('/not-found');
          }
        } catch (error) {
          console.error("Error checking data:", error);
        }
      };
  
      if (leadid && userId) { // Ensure values are defined before making the request
        checkDataExists();
      }
    }, [leadid, userId]);

  useEffect(() => {
    const fetchLeadData = async () => {
      try {
        const response = await axios.get(`${baseURL}/api/leads/${leadid}`);
        const leadData = response.data;

        setFormData((prev) => ({
          ...prev,
          leadid: leadData.leadid || "",
          lead_type: leadData.lead_type || "",
          leadcode: leadData.leadcode || "",
          name: leadData.name || "",
          email: leadData.email || "",
          country_code: leadData.country_code || "",
          another_country_code: leadData.another_country_code || "",
          phone_number: leadData.phone_number || "",
          origincity: leadData.origincity || "",
          destination: leadData.destination || "",
          description: leadData.description || "",
          another_name: leadData.another_name || "",
          another_email: leadData.another_email || "",
          another_phone_number: leadData.another_phone_number || "",
          corporate_id: leadData.corporate_id || "",
          primaryStatus: leadData.primaryStatus || "",
          secondaryStatus: leadData.secondaryStatus || "",
          primarySource: leadData.primarySource || "",
          secondarysource: leadData.secondarysource || "",
          channel: leadData.channel || "",
          created_at: leadData.created_at || "",
        }));
      } catch (err) {
        console.error("Error fetching lead data:", err);
        setError("Failed to fetch lead data.");
      }
    };

    if (leadid) {
      fetchLeadData();
    }
  }, [leadid]);


  useEffect(() => {
    const fetchLeadDetails = async () => {
      try {
        const response = await fetch(`${baseURL}/api/leadsoppcomment/${leadid}`);
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const data = await response.json();
        console.log(data);
        setLead(data || { comments: [] }); // Ensure lead is an object with comments
      } catch (error) {
        console.error('Error fetching lead details:', error);
      }
    };

    fetchLeadDetails();
  }, [leadid]);

  const addComment = async () => {
    if (!newComment.trim()) return;
    const trimmedComment = newComment.trim();
    const commentName = `${userName} (Manager)`;
    
    const comment = {
      name: commentName,
      leadid: leadid,
      timestamp: new Date().toISOString(),
      text: trimmedComment,
      notificationmessage: `${commentName}: ${trimmedComment}  `,
     
      userId: assignedSalesId,
      email: `${adminMail}`
    };
    
   
    console.log(JSON.stringify(comment, null, 2));
    console.log(assignedSalesId)

    try {
      const response = await fetch(`${baseURL}/comments/add`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(comment),
      });

      if (!response.ok) {
        throw new Error("Failed to add comment");
      }

      const savedComment = await response.json();

      // Update the state to display the new comment
      setLead((prevLead) => ({
        ...prevLead,
        comments: [...prevLead.comments, savedComment]
      }));

      setNewComment(''); // Clear input after submission
    } catch (error) {
      console.error('Error adding comment:', error);
    }
  };

  const sortedComments = lead.comments ? lead.comments.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp)) : [];

  const handleEdit = (leadId) => {
  if (source === "my-team-leads") {
    navigate(`/m-edit-lead/${leadId}`, {
      state: { leadid: leadId },
    });
  } else {
    navigate(`/m-myedit-lead/${leadId}`, {
      state: { leadid: leadId },
    });
  }
};

 const handleAddUser = (leadId) => {

  if (source === "my-team-leads") {
    navigate(`/m-create-customer-opportunity/${leadId}`, {
      state: { leadid: leadId },
    });
  } else {
    navigate(`/m-mycreate-customer-opportunity/${leadId}`, {
      state: { leadid: leadId },
    });
  }

};

  useEffect(() => {
  const fetchTags = async () => {
    try {
      const response = await axios.get(`${baseURL}/api/tags`);
      setAvailableTags(response.data);
    } catch (error) {
      console.error("Error fetching tags:", error);
    }
  };

  fetchTags();
}, []);

const fetchCustomerTags = async (customerId) => {
  try {
    setTagsLoading(true);

    const response = await axios.get(`${baseURL}/api/customers/${customerId}`);
    let tags = [];

    if (response.data.tags) {
      if (Array.isArray(response.data.tags)) {
        tags = response.data.tags;
      } else if (typeof response.data.tags === "string") {
        try {
          const parsedTags = JSON.parse(response.data.tags);
          if (Array.isArray(parsedTags)) {
            const tagResponse = await axios.get(`${baseURL}/api/tags`);
            tags = tagResponse.data.filter(tag =>
              parsedTags.includes(tag.id)
            );
          }
        } catch (e) {
          console.error("Error parsing tags:", e);
        }
      }
    }

    setCustomerTags(tags);
  } catch (error) {
    console.error("Error fetching customer tags:", error);
  } finally {
    setTagsLoading(false);
  }
};

useEffect(() => {
  if (lead?.lead?.customerid) {
    fetchCustomerTags(lead.lead.customerid);
  }
}, [lead]);

const handleTagChange = (event) => {
  setSelectedTagId(event.target.value);
};

const addTag = async () => {
  if (!selectedTagId || !lead?.lead?.customerid) return;

  setIsUpdating(true);

  try {
    const currentTagIds = customerTags.map(tag => tag.id);

    if (!currentTagIds.includes(parseInt(selectedTagId))) {
      const updatedTagIds = [...currentTagIds, parseInt(selectedTagId)];

      const response = await axios.put(
        `${baseURL}/api/customers/${lead.lead.customerid}/tags`,
        { tagIds: updatedTagIds }
      );

      setCustomerTags(response.data.tags);
      setMessage("Tag added successfully!");
    } else {
      setMessage("Tag already exists!");
    }
  } catch (error) {
    console.error("Error adding tag:", error);
  } finally {
    setIsUpdating(false);
    setSelectedTagId("");
  }
};

  const removeTag = async (tagIdToRemove) => {
  if (!lead?.lead?.customerid) return;

  setIsUpdating(true);

  try {
    const updatedTagIds = customerTags
      .filter(tag => tag.id !== tagIdToRemove)
      .map(tag => tag.id);

    const response = await axios.put(
      `${baseURL}/api/customers/${lead.lead.customerid}/tags`,
      { tagIds: updatedTagIds }
    );

    setCustomerTags(response.data.tags);
  } catch (error) {
    console.error("Error removing tag:", error);
  } finally {
    setIsUpdating(false);
  }
};

 useEffect(() => {
  const fetchTemplates = async () => {
    try {
      const res = await axios.get(`${baseURL}/api/templates`);
      setTemplates(res.data);
    } catch (err) {
      console.error("Error fetching templates", err);
    }
  };

  fetchTemplates();
}, []);

const handleTemplateCopy = (template) => {
  let formatted = `*${template.title}*\n\n${template.body}`;

  // 🔥 Dynamic replacements
  formatted = formatted
    .replace(/{name}/g, formData.name || "")
    .replace(/{email}/g, formData.email || "")
    .replace(/{phone}/g, formData.phone_number || "")
    .replace(/{leadid}/g, formData.leadid || "")
    .replace(/{destination}/g, formData.destination || "")
    .replace(/{city}/g, formData.origincity || "");

  navigator.clipboard.writeText(formatted);

  setMessage("Template copied!");
  setTimeout(() => setMessage(""), 1000);

  setShowTemplates(false);
};


  return (
    <div className="indeatilleadcontainer">
      <Navbar onToggleSidebar={setCollapsed} />
      <div className={`indeatilleadcontent ${collapsed ? "collapsed" : ""}`}>
        <div className="indetail-container">
          <div className="card mt-4">
            <div className="card-body">
              <h2 className="lead-details-header" style={{ "--theme-color": themeColor }}>Lead Details</h2>
              {message && <div className="alert alert-info">{message}</div>}
              {leadid ? (
                <div className="row">
                  <div className="col-md-6">

                    <div className="mb-3 d-flex align-items-center flex-wrap">
                      <span className="fw-bold me-2" style={{ minWidth: "150px" }}>
                        Lead ID: 
                      </span>
                      <span className="me-3">{formData.leadid}</span>
                      <button
                        className="btn btn-success btn-sm"
                        onClick={() => handleAddUser(leadid)}
                      >
                        Create Opportunity
                      </button>
                    </div>
                    <div className="mb-3 d-flex flex-wrap">
                      <span className="fw-bold me-2" style={{ minWidth: "150px" }}>
                        Name:
                      </span>
                      <span>{formData.name}</span>
                    </div>
                    <div className="mb-3 d-flex flex-wrap">
                      <span className="fw-bold me-2" style={{ minWidth: "150px" }}>
                        Email:
                      </span>
                      <span>{formData.email}</span>
                      <FaCopy
                        style={{ marginLeft: "8px", cursor: "pointer", color: "#ff9966" }}
                        onClick={() => copyToClipboard(formData.email)}
                        title="Copy Email"
                      />
                    </div>

                     <div className="mb-3 d-flex flex-wrap align-items-center position-relative">
  <span className="fw-bold me-2" style={{ minWidth: "150px" }}>
    Phone Number:
  </span>

  {/* WhatsApp Link */}
  <a
    href={`https://wa.me/${formData.country_code}${formData.phone_number}`}
    target="_blank"
    rel="noopener noreferrer"
    style={{ textDecoration: "none", color: "blue", marginRight: "10px" }}
  >
    {formData.country_code}{formData.phone_number}
  </a>

  {/* Copy Phone */}
  <FaCopy
    style={{ marginRight: "10px", cursor: "pointer", color: "#ff9966" }}
    onClick={() => copyToClipboard(`${formData.country_code}${formData.phone_number}`)}
    title="Copy Phone"
  />

  {/* 🔥 Templates Button */}
  <button
    className="btn btn-sm btn-outline-success"
    onClick={() => setShowTemplates(!showTemplates)}
  >
    Templates
  </button>

  {/* 🔥 Templates Dropdown */}
  {showTemplates && (
    <div
      style={{
        position: "absolute",
        top: "40px",
        left: "150px",
        width: "300px",
        maxHeight: "250px",
        overflowY: "auto",
        background: "#fff",
        border: "1px solid #ccc",
        borderRadius: "6px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
        zIndex: 1000,
        padding: "10px"
      }}
    >
      <strong>Select Template</strong>

     {templates.length > 0 ? (
  templates.map((t) => {
    let preview = t.body
      .replace(/{name}/g, formData.name || "")
      .replace(/{email}/g, formData.email || "");

    return (
      <div
        key={t.id}
        title={preview}   // 🔥 HOVER FULL TEXT
        style={{
          padding: "8px",
          borderBottom: "1px solid #eee",
          cursor: "pointer",
          transition: "0.2s",
        }}
        onClick={() => handleTemplateCopy(t)}
        onMouseEnter={(e) => e.currentTarget.style.background = "#f5f5f5"}
        onMouseLeave={(e) => e.currentTarget.style.background = "#fff"}
      >
        <b>{t.title}</b>

        {/* 🔥 SHORT PREVIEW */}
        <div style={{ fontSize: "12px", color: "#555" }}>
          {preview.length > 40
            ? preview.slice(0, 40) + "..."
            : preview}
        </div>
      </div>
    );
  })
) : (
  <p>No templates found</p>
)}
    </div>
  )}
</div>

                    <div className="mb-3 d-flex flex-wrap">
                      <span className="fw-bold me-2" style={{ minWidth: "150px" }}>
                        Primary Source:
                      </span>
                      <span>{formData.primarySource}</span>
                    </div>
                    <div className="mb-3 d-flex flex-wrap">
                      <span className="fw-bold me-2" style={{ minWidth: "150px" }}>
                        Secondary Source:
                      </span>
                      <span>{formData.secondarysource}</span>
                    </div>
                    {/* TAG SECTION */}

                    <div style={{ marginTop: "20px" }}>
                      <strong>Tags:</strong>
                      <div style={{ display: "flex", flexWrap: "wrap", gap: "8px", marginTop: "10px" }}>
                        {tagsLoading ? (
                          <span style={{ color: "#888" }}>Loading tags...</span>
                        ) : customerTags.length > 0 ? (
                          customerTags.map(tag => (
                            <span
                              key={tag.id}
                              style={{
                                background: "#6c757d",
                                color: "#fff",
                                padding: "6px 10px",
                                borderRadius: "12px",
                                display: "flex",
                                alignItems: "center"
                              }}
                            >
                              {tag.label}
                              <FaTimes
                                style={{ marginLeft: "8px", cursor: "pointer" }}
                                onClick={() => removeTag(tag.id)}
                              />
                            </span>
                          ))
                        ) : (
                          <span>No tags</span>
                        )}
                      </div>
                    </div>

                    <div style={{ display: "flex", alignItems: "center", marginTop: "10px", gap: "10px", marginBottom: "20px" }}>
                      <strong style={{ fontSize: '16px' }}>Add Tag:</strong>
                      <select
                        value={selectedTagId}
                        onChange={handleTagChange}
                        style={{ 
                          width: "50%", 
                          padding: "8px 12px",
                          fontSize: '14px',
                          borderRadius: '6px',
                          border: '1px solid #ccc'
                        }}
                      >
                        <option value="">Select Tag</option>
                        {availableTags.map(tag => {
                          const exists = customerTags.some(t => t.id === tag.id);
                          if (!exists) {
                            return (
                              <option key={tag.id} value={tag.id}>
                                {tag.label}
                              </option>
                            );
                          }
                          return null;
                        })}
                      </select>
                      <FaCheck
                        style={{ cursor: "pointer", color: "green", fontSize: "20px" }}
                        onClick={addTag}
                      />
                    </div>
                    <div className="mb-3 d-flex flex-wrap">
                      <span className="fw-bold me-2" style={{ minWidth: "150px" }}>
                        Origin City:
                      </span>
                      <span>{formData.origincity}</span>
                    </div>
                    <div className="mb-3 d-flex flex-wrap">
                      <span className="fw-bold me-2" style={{ minWidth: "150px" }}>
                        Destination:
                      </span>
                      <span>{formData.destination}</span>
                    </div>

                    <div className="mb-3 d-flex flex-wrap">
                      <span className="fw-bold me-2" style={{ minWidth: "150px" }}>
                        Secondary Email:
                      </span>
                      <span>{formData.another_email}</span>
                    </div>
                    <div className="mb-3 d-flex flex-wrap">
                      <span className="fw-bold me-2" style={{ minWidth: "150px" }}>
                        Secondary Phone Number:
                      </span>
                      <span>{formData.another_country_code} {formData.another_phone_number}</span>
                    </div>

                    <div className="mb-3 d-flex flex-wrap">
                      <span className="fw-bold me-2" style={{ minWidth: "150px" }}>
                        Primary Status:
                      </span>
                      <span>{formData.primaryStatus}</span>
                    </div>
                    <div className="mb-3 d-flex flex-wrap">
                      <span className="fw-bold me-2" style={{ minWidth: "150px" }}>
                        Secondary Status:
                      </span>
                      <span>{formData.secondaryStatus}</span>
                    </div>
                    <div className="mb-3 d-flex flex-wrap">
                      <span className="fw-bold me-2" style={{ minWidth: "150px" }}>
                        channel:
                      </span>
                      <span>{formData.channel}</span>
                    </div>
                    <div className="mb-3 d-flex flex-wrap">
                      <span className="fw-bold me-2" style={{ minWidth: "150px" }}>
                        Created Date:
                      </span>
                      <span>{new Date(formData.created_at).toLocaleString("en-IN", { timeZone: "Asia/Kolkata" })}</span>
                    </div>
                      <div className="mb-3 d-flex flex-wrap">
                      <span className="fw-bold me-2" style={{ minWidth: "150px" }}>
                        Description:
                      </span>
                      <span style={{ whiteSpace: "pre-line" }}>{formData.description}</span>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="comment-section-container">
                      <p><strong>Comments:</strong></p>
                      <div className="comment-input-container">
                        <Form.Group>
                          <Form.Label><strong>Add a New Comment</strong></Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={4}
                            placeholder="Write your comment here..."
                            value={newComment}
                            onChange={(e) => setNewComment(e.target.value)}
                            autoFocus
                          />
                          <Button
                            className="mt-2 btn-warning text-white"
                            onClick={addComment}
                            disabled={!newComment.trim()}
                          >
                            Add Comment
                          </Button>
                        </Form.Group>
                      </div>
                      <div className="comment-list" style={{ maxHeight: "300px", overflowY: "auto", border: "1px solid #ddd", padding: "10px", borderRadius: "5px", marginTop: "15px",backgroundColor:"#f1f7ff" }}>
                        {sortedComments.length > 0 ? (
                          sortedComments.map((comment) => (
                            <div key={comment.id} className="comment-item">
                              <p className="comment-timestamp">
                                {new Date(comment.timestamp).toLocaleString("en-IN", {
                                  timeZone: "Asia/Kolkata",
                                  day: "2-digit",
                                  month: "2-digit",
                                  year: "numeric",
                                  hour: "2-digit",
                                  minute: "2-digit",
                                  second: "2-digit",
                                  hour12: true,
                                })}
                              </p>
                              <p className="comment-text">
                                <strong>{comment.name}</strong>:  
                                <span style={{ whiteSpace: "pre-line" }}>{comment.text}</span>
                              </p>
                              <hr />
                            </div>
                          ))
                        ) : (
                          <p>No comments available.</p>
                        )}
                      </div>
                    </div>

                    {/* Reminder Setting Form */}
                    <hr />
                    <Form onSubmit={handleReminderSubmit}>
                      <Form.Group className="mb-3">
                        <Form.Label>Reminder Setting</Form.Label>
                        <Form.Control
                          type="datetime-local"
                          name="reminder_setting"
                          value={reminderFormData.reminder_setting}
                          onChange={handleReminderChange}
                          min={new Date().toISOString().slice(0, 16)}
                        />
                      </Form.Group>

                      <Form.Group className="mb-3">
                        <Form.Label>Notes</Form.Label>
                        <Form.Control
                          as="textarea"
                          name="notes"
                          value={reminderFormData.notes}
                          onChange={handleReminderChange}
                          rows={3}
                        />
                      </Form.Group>

                      <Button
                        className="mt-2 btn-warning text-white"
                        type="submit"
                      >
                        Submit Reminder
                      </Button>
                    </Form>

                      {/* Reminder History */}
                      <div style={{ marginTop: "30px" }}>
                        <h5>Reminder History</h5>
                        <div 
                          className="reminder-history-list" 
                          style={{
                            maxHeight: "250px",
                            overflowY: "auto",
                            border: "1px solid #ddd",
                            borderRadius: "5px",
                            padding: "10px",
                            backgroundColor: "#f1f7ff",
                          }}
                        >
                          {reminderHistory.length > 0 ? (
                            reminderHistory.map((reminder, index) => (
                              <div 
                                key={reminder.id || index} 
                                style={{
                                  padding: "10px",
                                  borderBottom: index !== reminderHistory.length - 1 ? "1px solid #eee" : "none",
                                  marginBottom: "8px",
                                  position: "relative"
                                }}
                              >
                                <div style={{ 
                                  fontSize: "0.85rem", 
                                  color: "#6c757d",
                                  marginBottom: "5px",
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center"
                                }}>
                                  <span>
                                    <strong>Created:</strong>{" "}
                                    {new Date(reminder.created_at).toLocaleString("en-IN", {
                                      timeZone: "Asia/Kolkata",
                                      day: "2-digit",
                                      month: "2-digit",
                                      year: "numeric",
                                      hour: "2-digit",
                                      minute: "2-digit"
                                    })}
                                  </span>
                                  {/* <FaTrash 
                                    style={{ 
                                      cursor: "pointer", 
                                      color: "#dc3545",
                                      fontSize: "15px",
                                      transition: "opacity 0.2s"
                                    }}
                                    onClick={() => handleDeleteReminder(reminder.id, reminder.lead_id)}
                                    title="Delete reminder"
                                  /> */}
                                </div>
                                
                                <div style={{ 
                                  fontSize: "0.95rem",
                                  whiteSpace: "pre-line",
                                  marginBottom: "5px"
                                }}>
                                  <strong>Notes:</strong> {reminder.notes || "No notes"}
                                </div>
                                
                                <div style={{ 
                                  fontSize: "0.95rem",
                                  whiteSpace: "pre-line",
                                  marginTop: "5px",
                                  padding: "4px 8px",
                                  borderRadius: "4px",
                                  backgroundColor: reminder.action === "reminderdsss" ? "#cce5ff56" : "#e2e3e5",
                                }}>
                                  <strong>Action:</strong> {reminder.action || "No action"}
                                </div>
                              </div>
                            ))
                          ) : (
                            <p style={{ textAlign: "center", color: "#6c757d", margin: "20px 0" }}>
                              No reminder history available
                            </p>
                          )}
                        </div>
                      </div>

                  </div>
                
                </div>
              ) : (
                !error && <p>Loading lead details...</p>
              )}
            </div>
          </div>

          <div className="back-button mt-3 d-flex gap-3">
            <button
              className="btn btn-secondary"
              onClick={() => navigate(-1)}
            >
              Back
            </button>
            <button
              className="btn btn-primary"
              onClick={() => handleEdit(leadid)}
            >
              Edit
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InDetailViewLeads;